import React from 'react';
import { CBRetentionLogo } from '@bbkAdminComponents/cbretention-logo';
import { SignupPaths } from '@bbkAdminRouter/signup-paths';
import { Link } from '@bbkShared/react-router';

export const TrialSignupLogo: React.FC = () => (
  <Link
    to={SignupPaths.trialSignup}
    className="tw-inline-block tw-max-w-[300px]"
  >
    <CBRetentionLogo />
  </Link>
);
